import { render, staticRenderFns } from "./create-password.vue?vue&type=template&id=5d9a23a5&"
import script from "./create-password.vue?vue&type=script&lang=ts&"
export * from "./create-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports